var map = {
	"./example": 78346,
	"./example.json": 78346,
	"./商品示例1.jpg": 50929,
	"./商品示例2.jpg": 24921,
	"./商品示例3.jpg": 86001,
	"./模特视频1.jpg": 43881,
	"./模特视频2.jpg": 84797,
	"./示例-上装1.png": 79441,
	"./示例-上装2.png": 23582,
	"./示例-上装3.png": 46149,
	"./示例-上装4.png": 84204,
	"./示例-上装5.png": 33615,
	"./示例-上装6.png": 893,
	"./示例-裙子1.png": 86958,
	"./示例-裙子2.png": 78559,
	"./示例-裙子3.png": 10851,
	"./示例1-女士吊带背心.jpg": 56121,
	"./示例1-女士背带裙.jpg": 95570,
	"./示例2-女士挂脖连衣裙.jpg": 49510,
	"./示例2-女士白色印花短T恤.jpg": 62502,
	"./示例3-下装1.png": 16830,
	"./示例3-下装2.png": 28438,
	"./示例3-下装3.png": 99598,
	"./示例3-女士挂脖连衣裙2.jpg": 94251,
	"./示例3-女士纯白短T恤.jpg": 72522,
	"./示例4-男士长袖衬衫.jpg": 34817,
	"./示例5-男士西装外套.jpg": 52974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48965;